// src/config/runtime.js
// Single source of truth for "where does this build talk to the backend?"
//
// The same compiled bundle ships two ways:
//   1. Web — hosted on Heroku, served same-origin. API + sockets are
//      relative / same-origin. (Capacitor.isNativePlatform() === false)
//   2. Native — bundled inside the Android APK / iOS app. The WebView
//      origin is https://localhost (Android) or capacitor://localhost
//      (iOS), so relative '/api' would 404. We must point at the absolute
//      Heroku origin. (Capacitor.isNativePlatform() === true)
//
// Detecting at RUNTIME (not build time) means we don't need a separate
// "native build" — `npm run build` output works in both contexts.

import { Capacitor } from '@capacitor/core';

// The production backend the native app talks to. Overridable at build
// time via REACT_APP_NATIVE_API_ORIGIN for staging / self-host builds.
const NATIVE_API_ORIGIN =
	(process.env.REACT_APP_NATIVE_API_ORIGIN || 'https://catering-portal-a76f32c3144f.herokuapp.com').replace(/\/+$/, '');

export const isNative = () => {
	try {
		return Capacitor.isNativePlatform();
	} catch (e) {
		return false;
	}
};

export const getPlatform = () => {
	try {
		return Capacitor.getPlatform(); // 'web' | 'android' | 'ios'
	} catch (e) {
		return 'web';
	}
};

// Absolute origin of the backend, or '' for same-origin (web).
export const getApiOrigin = () => {
	if (isNative()) return NATIVE_API_ORIGIN;
	// Web: allow an explicit override (e.g. split front/back hosting),
	// else same-origin relative.
	return (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');
};

// Axios baseURL. Native → https://host/api ; web → /api (or override).
export const getApiBaseUrl = () => `${getApiOrigin()}/api`;

// Socket.io connection target. Native → Heroku origin ; web → explicit
// REACT_APP_SERVER_URL, else same-origin (undefined lets socket.io infer
// window.location), else localhost in dev.
export const getSocketUrl = () => {
	if (isNative()) return NATIVE_API_ORIGIN;
	if (process.env.REACT_APP_SERVER_URL) return process.env.REACT_APP_SERVER_URL;
	if (typeof window !== 'undefined' && window.location && process.env.NODE_ENV === 'production') {
		return window.location.origin;
	}
	return 'http://localhost:8081';
};

// Resolve a server-relative asset path (e.g. "/uploads/meals/x.png") to an
// absolute URL when running natively. Full URLs (http..., data:, blob:)
// and same-origin web paths pass through untouched.
export const resolveAssetUrl = (pathOrUrl) => {
	if (!pathOrUrl || typeof pathOrUrl !== 'string') return pathOrUrl;
	if (/^(https?:|data:|blob:|capacitor:)/i.test(pathOrUrl)) return pathOrUrl;
	if (!isNative()) return pathOrUrl; // web: relative is fine
	if (pathOrUrl.startsWith('/')) return `${NATIVE_API_ORIGIN}${pathOrUrl}`;
	return pathOrUrl;
};

export const NATIVE_ORIGIN = NATIVE_API_ORIGIN;
